import { useState, type FC } from "react";

import { CircularProgress, type ButtonBaseProps } from "@mui/material";
import { useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";

import "./Button.scss";

interface BasicButtonProps extends ButtonBaseProps {
  text: string;
  path?: string;
  onClick?: () => void;
  isProgress?: boolean;
  color?: string;
}

export const BasicButton: FC<BasicButtonProps> = ({
  text,
  path,
  onClick,
  isProgress,
  color,
  disabled,
  ...buttonProps
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  return (
    <Button
      {...buttonProps}
      disabled={disabled || isProgress || isLoading}
      disableTouchRipple
      // @ts-ignore
      sx={{ ...buttonProps.sx, fontSize: buttonProps.sx?.fontSize || "large" }}
      className="basic-button"
      onClick={() => {
        if (isLoading) return;
        setIsLoading(true);
        if (onClick) onClick();
        if (!path) return setIsLoading(false);
        navigate(path);
        setIsLoading(false);
      }}
    >
      {isProgress ? (
        <CircularProgress
          size={color ? 20 : 35}
          style={{ color: color ? color : "white" }}
        />
      ) : (
        text
      )}
    </Button>
  );
};
